import { render, staticRenderFns } from "./shoppingCart.vue?vue&type=template&id=c2fb0420&scoped=true"
import script from "./shoppingCart.vue?vue&type=script&lang=js"
export * from "./shoppingCart.vue?vue&type=script&lang=js"
import style0 from "./shoppingCart.vue?vue&type=style&index=0&id=c2fb0420&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2fb0420",
  null
  
)

export default component.exports